import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { get as _get } from 'lodash';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { fromRouterActions } from '@amfam/shared/utility/navigation';

import * as fromRoot from '../../core/store';
import * as coverageChangeSelector from '../+state';

@Injectable({
  providedIn: 'root'
})
export class CoverageChangeGuard {
  constructor(private store: Store<fromRoot.RootState>) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.store.select(coverageChangeSelector.getSelectedVehicleIdentifier).pipe(
      take(1),
      switchMap(vehicleId => {
        if (vehicleId) {
          if (vehicleId === _get(next, 'params.id') || state.url.indexOf('confirmation') !== -1) {
            return of(true);
          }
        }
        this.store.dispatch(
          fromRouterActions.Go({
            path: ['/policies']
          })
        );
        return of(false);
      })
    );
  }
}
